const regex = /\/page\/\d{1,2}$/;

export const getInitialPage = (that: any): number => {
  if (regex.test(location.href)) {
    that.currentPage = location.href.charAt(location.href.length - 1);
    return that.currentPage;
  }
  return 1;
}

export const updateHistorySearch = (that: any): void => {
  window.history.pushState('', '',
    regex.test(location.href)
      ? `${location.href.substr(0, location.href.length - 1)}${that.currentPage}`
      : `${location.href}/page/${that.currentPage}`,
  );
}



// WEBPACK FOOTER //
// ./src/app/shared/components/pagination/pagination.utils.ts